import React, { useEffect } from 'react';

import './List.css';

import { truncate } from '../../Utils/services';

export const List = ({ item, mode, handleMediaClick }) => {
  useEffect(() => {}, []);

  return (
    <div className={'list-item ' + mode}>
      <div className='item-header' style={{ borderColor: item.color }}>
        <div className='item-title' onClick={() => handleMediaClick(item)}>
          {item.headline}
        </div>
        <div className='item-subtitle'>
          by <span>{item.media}</span>
        </div>
      </div>
      <div>{truncate(item.summary)}</div>
      <div className='item-action'>
        <a href={item.link} target='_blank' rel='noreferrer'>
          Read more
        </a>
      </div>
      {mode === 'detailed' && (
        <div className='item-footer'>
          <div>
            <span>Stance score:</span>
            <b>{item.y}</b>
          </div>
        </div>
      )}
    </div>
  );
};
